export default function ($translate) {
    return {
        KEYS: {
            SUPER_ADMIN: 'SUPER_ADMIN'
        },
        LABELS: {
            SUPER_ADMIN: $translate.instant('auth.privilege.superAdmin')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/auth/privilege/index.js